import MultiSelectInput from '@repo/ui/multiselect-input'

import { TripGroupingFilters } from '../../lib/types/models/trip-grouping/trip-grouping'
import { yearsFilterOptions } from '../pcr-personal-space/utils'

type Props = {
  filter?: TripGroupingFilters
  onFilterChange: (filter: TripGroupingFilters) => void
}

const TripGroupingFilter: React.FC<Props> = ({ filter, onFilterChange }) => {
  return (
    <div className="flex flex-col gap-4 mt-2">
      <MultiSelectInput<number>
        label={'Année'}
        variant={'primary'}
        options={yearsFilterOptions}
        selectedOptions={filter?.years?.map((year) => ({
          label: yearsFilterOptions.find((y) => y.value === year)?.label ?? '',
          value: year
        }))}
        onChange={(years) => onFilterChange({ ...filter, years })}
      />
    </div>
  )
}

export default TripGroupingFilter
